import { useEffect, useState } from 'react';
import { createBrowserHistory } from 'history';
import { monitoring } from '@tcc/analytics';

const history = createBrowserHistory();

const { createTimeEvent } = monitoring;

export const useHistoryListener = (webAnalyticsMonitoringFlag: boolean): void => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setSavedHash] = useState('');
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    // TODO: remove conditional after FEWEB-1305
    if (webAnalyticsMonitoringFlag) {
      const [hash] = history.location.hash.split('?');

      setSavedHash(hash);

      const unmount = history.listen(update => {
        const [hash] = update.location.hash.split('?');

        setSavedHash((from) => {
          if (from === hash) return from;

          createTimeEvent({ eventName: 'pageTransition', details: { from, to: hash } });

          return hash;
        });
      });

      return unmount;
    }
  }, [webAnalyticsMonitoringFlag]);

  return null;
};
